module.exports = __webpack_public_path__ + "img/box2_img3.2b090ca8.png";